import { Dialog } from "@headlessui/react";
import { IKImage } from "imagekitio-react";
import React from "react";
import { useSelector } from "react-redux";
import Constants from "../../common/constants";
import { Mixpanel } from "../../config/Mixpanel";
import ExitTimer from "./ExitTimer";

const ExitPopUp = ({
  isModalEnabled,
  setIsModalEnabled,
  setDowngradeModal,
  countDownDate,
  setIsDiscount,
}) => {
  const user_name = useSelector((store) => store?.profileDetails?.name);
  const email = useSelector((store) => store?.profileDetails?.email);
  return (
    <Dialog
      open={isModalEnabled}
      onClose={() => null}
      as="div"
      style={{ zIndex: "9999999999" }}
      className="fixed inset-0 z-10 -mt-10 flex flex-col items-center justify-center overflow-y-auto md:mt-20 md:justify-start"
    >
      <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />
      <Dialog.Title />
      <Dialog.Description />
      <div className="relative z-10 flex  lg:w-[28%] w-[95%] flex-col items-center justify-center overflow-auto rounded-xl bg-white py-4 px-2 text-center shadow-2xl  md:p-4">
        <img
          urlEndpoint="https://assets.learntube.ai/files/"
          src="https://assets.learntube.ai/files/8_day_journey/Layer_1.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1677735848619"
          transformation={[
            {
              height: "150",
              width: "150",
            },
          ]}
          className="h-40 w-40"
        />
        <h1 className="mt-2 text-xl font-bold">{user_name?.split(" ")?.[0]}?</h1>
        <div className="text-xl font-bold">Please Choose an Option!</div>
        <div className="mt-2 text-sm font-medium">
          To continue using the platform & growing your career, select the plan
          you want to invest in.
        </div>
        <div className="mt-2 flex w-full flex-col items-center justify-center">
          <div className="flex w-full items-center justify-center">
            <button
              className="mt-3 mr-1 w-1/2 rounded-lg border-2 border-[#E5303E] px-2 py-2 text-sm font-medium text-[#E5303E] md:text-sm"
              onClick={() => {
                Mixpanel.track(Constants.Mixpanel.WALL_DOWNGRADE_EXIT, {
                  distinct_id: email
              });
                setIsModalEnabled(false);
                setDowngradeModal(true);
              }}
            >
              Downgrade
            </button>
            <button
              className="mt-3 ml-1 w-1/2 rounded-lg border-2 border-[#13B284] bg-[#13B284] px-4 py-2 text-sm font-medium text-white md:text-sm"
              onClick={() => {
                setIsModalEnabled(false);
                Mixpanel.track(Constants.Mixpanel.WALL_EXPLORE_ALL, {
                  distinct_id: email
              });
              }}
            >
              Explore All Plans
            </button>
          </div>
          <div className="mt-1 ml-12 self-start text-xs font-medium">
            To Free Plan
          </div>
        </div>
        <ExitTimer
          countDownDate={countDownDate}
          setIsDiscount={setIsDiscount}
        />
      </div>
    </Dialog>
  );
};

export default ExitPopUp;
